import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { IconColumns, IconLayoutRows } from '@tabler/icons-react';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { type IWidgetConfigurationSlot } from '../../common/config-slots/IWidgetConfigurationSlot.ts';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '../../common/config-slots/WidgetConfigurationSlots.tsx';
import { CodeLabelInputForm } from '../../inputs/common/CodeLabelInputForm.tsx';
import { TableColumnWidgetList } from './columns/TableColumnWidgetList.tsx';
import { type ITableInputWidget } from './ITableInputWidget.ts';
import { TableRowsWidgetList } from './rows/TableRowsWidgetList.tsx';

/** Card "Righe Tabella": etichetta e variabili di riga. */
const TableRowsSlot: IWidgetConfigurationSlot = {
  key: 'table-rows',
  title: 'Righe Tabella (Variabile Campo)',
  icon: <TbIcon icon={IconLayoutRows} />,
  description: 'Etichetta e variabili di riga della tabella.',
  order: 15,
};

/** Card "Colonne Tabella": campi di input delle colonne. */
const TableColumnsSlot: IWidgetConfigurationSlot = {
  key: 'table-columns',
  title: 'Colonne Tabella (Campi di input)',
  icon: <TbIcon icon={IconColumns} />,
  description: 'Campi di input che compongono le colonne della tabella.',
  order: 16,
};

export interface ITableInputWidgetConfigComponentProps
  extends IWidgetComponentProps<ITableInputWidget> {}

export function TableInputWidgetConfigComponent(
  props: ITableInputWidgetConfigComponentProps,
) {
  return (
    <>
      <CodeLabelInputForm hideLabel hideColSpan />
      <WidgetConfigurationSlotRender
        slot={WidgetConfigurationSlots.Layout}
        order={40}
      >
        <FormItem
          name="layout.rowsLabelColumnWidth"
          label="Larghezza colonna delle etichette delle Righe"
        >
          <NumberInput name="layout.rowsLabelColumnWidth" addonAfter="%" />
        </FormItem>
        <RowElement>
          <FormItem name="layout.hideTableHeader">
            <CheckboxInput name="layout.hideTableHeader" defaultChecked={false}>
              Nascondi intestazione tabella
            </CheckboxInput>
          </FormItem>
          <FormItem name="layout.lightTableHeader">
            <CheckboxInput
              name="layout.lightTableHeader"
              defaultChecked={false}
            >
              Intestazione tabella con sfondo bianco
            </CheckboxInput>
          </FormItem>
        </RowElement>
      </WidgetConfigurationSlotRender>
      {/* Titolo Tabella */}
      {/* <FormItem name="layout.showTableTitle">
            <CheckboxInput name="layout.showTableTitle" defaultChecked={false}>
              Mostra titolo tabella
            </CheckboxInput>
          </FormItem>
          <FormItem name="layout.tableTitle" label="Titolo della tabella">
            <RichTextInput
              name="layout.tableTitle"
              rows={2}
              menus={MenuPresets.Minimal}
            />
          </FormItem> */}

      <WidgetConfigurationSlotRender slot={TableRowsSlot}>
        <div>
          <FormItem name="label" label="Etichetta per le Righe">
            <RichTextAdvancedInput
              name="label"
              rows={2}
              menus={MenuPresets.Minimal}
            />
          </FormItem>
        </div>

        <TableRowsWidgetList name="rows" />
      </WidgetConfigurationSlotRender>
      <WidgetConfigurationSlotRender slot={TableColumnsSlot}>
        <TableColumnWidgetList name="columns" />
      </WidgetConfigurationSlotRender>
    </>
  );
}
